


































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { Action } from 'vuex-class'

@Component({
  computed: {
    ...mapState({
      predefinedAmountsState: ({ cashierContext }: any) => cashierContext.config.predefinedAmounts,
      userBalance: ({ gamblingContext }: any) => gamblingContext.userBalance.balance,
      currencyCode: ({ gamblingContext }: any) => gamblingContext.currencyCode
    })
  }
})
export default class Amounts extends Vue {
  @Prop(String) method!: string
  @Prop(Function) nextStep!: any

  predefinedAmountsState!: any
  choosedAmount: number | string = 200
  userBalance!: number
  errorText: string = ''
  currencyCode!: string
  checkoutTheme: boolean = false

  get predefinedAmounts () {
    return [
      ...this.predefinedAmountsState,
      'Custom'
    ]
  }

  customBtn (amount: number | string): boolean {
    return !this.predefinedAmountsState.includes(this.choosedAmount) && amount === 'Custom'
  }

  setAmount (val: any): any {
    if (val === 'Custom') {
      this.choosedAmount = Number(0)
      return
    }
    this.choosedAmount = Number(val)
  }

  validateAmount (): any {
    if (this.method === 'withdrawal') {
      if (this.choosedAmount > this.userBalance) {
        this.errorText = 'You do not have enough money in your account'
        return null
      }
    }
    this.nextStep(this.choosedAmount)
  }

  clearError (): void {
    this.errorText = ''
  }

  get amountTooBig (): boolean {
    return this.errorText.length > 0
  }

  get buttonText (): string {
    const method = this.method.replace('al', '')
    return this.choosedAmount > 0 ? `${method} ${ this.currencyCode }${this.choosedAmount}` : 'Set amount'
  }

  get getCols (): number {
    return this.predefinedAmounts.length / 12
  }

  created () {
    const theme = document.querySelector('#gambling-checkout-vars')
    const checkTheme = theme && theme.innerHTML.includes('checkout-theme:light')
    if (checkTheme) {
      this.checkoutTheme = true
    } else {
      this.checkoutTheme = false
    }
  }
}
